var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.373,
    height: 98.369,
    viewBox: "0 0 98.373 98.369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-copy-1186909",
    transform: "translate(-0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8989",
    "data-name": "Path 8989",
    d: "M212.559,137.473V70.918a1.2,1.2,0,0,0-1.273-1.273H140.913a1.2,1.2,0,0,0-1.273,1.273v6.108h-6.363V68.373a5.1,5.1,0,0,1,5.09-5.09h75.466a5.1,5.1,0,0,1,5.09,5.09v71.519a5.1,5.1,0,0,1-5.09,5.09H206.2v-6.363h5.09a1.169,1.169,0,0,0,1.273-1.144Z",
    transform: "translate(-120.548 -63.283)",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8990",
    "data-name": "Path 8990",
    d: "M211.05,136.64h71.773a5.1,5.1,0,0,1,5.09,5.09v71.519a5.1,5.1,0,0,1-5.09,5.09H211.177a5.1,5.1,0,0,1-5.09-5.09V141.73a4.919,4.919,0,0,1,4.963-5.09Zm1.273,74.191A1.2,1.2,0,0,0,213.6,212.1h66.683a1.2,1.2,0,0,0,1.273-1.273V144.275A1.2,1.2,0,0,0,280.278,143H213.723a1.2,1.2,0,0,0-1.273,1.273V210.83Z",
    transform: "translate(-206.082 -119.97)",
    fill: "#5f5f5f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.e85437779a37cf3bbc0f6104a59ebb82.svg";
export { ForwardRef as ReactComponent };